/** How long a row of the thread takes to rise and fade in. */
export const ARRIVAL_MS = 240;
const ARRIVAL_RISE_PX = 8;
const ARRIVAL_EASING = 'cubic-bezier(0.22, 1, 0.36, 1)';

const keyframes = {
  '@keyframes threadArrival': {
    from: { opacity: 0, transform: `translateY(${ARRIVAL_RISE_PX}px)` },
    to: { opacity: 1, transform: 'none' },
  },
};

/** Rises and fades in a row as it lands in the thread. */
export const arrivalSx = {
  ...keyframes,
  animation: `threadArrival ${ARRIVAL_MS}ms ${ARRIVAL_EASING}`,
  '@media (prefers-reduced-motion: reduce)': { animation: 'none' },
};

/**
 * Brings a step's answers in once the message asking it has landed, so they
 * never show before the question does. Held hidden until then.
 */
export const answersArrivalSx = {
  ...keyframes,
  animation: `threadArrival ${ARRIVAL_MS}ms ${ARRIVAL_EASING} ${ARRIVAL_MS}ms both`,
  '@media (prefers-reduced-motion: reduce)': { animation: 'none' },
};
